<template>
  <div class="  section_sectionWrapper">
    <div class="module-home">
      <video class="home_video__jx2_E" loop muted autoplay playsinline="">
        <source src="https://resource-mp4.ujoygames.com/ashechoes/bg.mp4" type="video/mp4">
      </video>
      <!-- 内容区域 -->
      <div class="kv-title"></div>
      <div class="mail">
        <div class="m-lf">
          <div class="title"></div>
          <div class="input-bg">
            <input type="text" class="inpuy-style" autocomplete="off" :placeholder="emailPlaceholder"
              v-model="account" />
          </div>
          <div class="pr" @click="handlePolicy">

            <div class="c-active-img" v-if="policy"></div>
            <div class="c-img" v-else></div>
            <a href="https://privacy.ujoygames.jp/" target="_blank">
              <div class="c-1   c-text"></div>
            </a>
          </div>
        </div>
        <div class="m-reg" @click="AE_Mail_reg()"></div>
      </div>
    </div>


    <!-- err -->
    <div class="err-model model" v-if="errModel">
      <div class="err-detail">
        <img :src="require('../../assets/img/home/regCode-' + regCode + '.png')" alt="" srcset="">
        <div class="err-close" @click="handleErrClose"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',

  data() {
    return {
      emailPlaceholder: "メールアドレスを入力してください",
      account: "", // 账号
      regCode: -1,
      policy: true,
      errModel: false
    }
  },
  watch: {

  },
  methods: {
    handlePolicy() {
      this.policy = !this.policy
    },
    handleErrClose() {
      this.errModel = false
      this.regCode = -1
    },
    // 预注册接口
    AE_Mail_reg() {

      const reg = new RegExp(
        /^[a-z0-9]+([._\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      );


      if (this.account === "" || !reg.test(this.account)) {
        this.regCode = 1
        setTimeout(this.errModel = true, 500)
        // return
      } else if (!this.policy) {
        this.regCode = 3
        setTimeout(this.errModel = true, 500)
        // return
      } else {
        //   邮箱输入正确后，调API
        const reqTime = Math.floor(new Date().getTime() / 1000);
        let source = this.common.getUrlParam("source") || "unknow";
        let target = this.common.getUrlParam("target") || "unknow";

        // 计算signature
        const params = {
          account: this.account,
          game: "211",
          type: 1,
        };
        this.$axios({
          method: "post",
          url: "ashechoes/subscribe",
          data: {
            account: this.account,
            game: "211",
            type: 1,
            signature: this.common.makeSignature(params, reqTime),
            reqTime: reqTime,
            source: source,
            target: target,
          },
          //withCredentials:true, //局部携带cookie
          headers: {}, //如果需要添加请求头可在这写
        })
          .then((res) => {

            if (res.data.code === 0) {
              this.regCode = 0
              this.account = ''
              gtag('event', '邮箱预约按钮点击');


            } else {
              this.regCode = 2
            }

            setTimeout(this.errModel = true, 500)
          })
          .catch((err) => { });
      }


    },


  }
}
</script>
<style lang="scss" scoped>
.module-home {
  position: relative;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-image: url("../../assets/img/home_bg.jpg");
  z-index: 10;


  // overflow: hidden;
  // background: url("../../assets/img/home_bg.jpg") no-repeat center top;
  // width: 1920px;
  // height: 1080px;
  // background-size: 100% 100%;
  // position: relative;

  .home_video__jx2_E {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  .kv-title {
    width: 836px;
    height: 385px;
    background-size: 100% 100%;
    background-image: url("../../assets/img/home/slogan.png");
    z-index: 1;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .mail {
    position: absolute;
    bottom: 10vh;
    left: 50%;
    transform: translate(-50%, 0);
    justify-content: center;
    display: flex;
    align-items: center;
    cursor: pointer;

    .m-lf {
      .title {
        width: 128px;
        height: 40px;
        background-size: 100% 100%;
        background-image: url("../../assets/img/home/login-title.png");
      }

      .input-bg {
        width: 479px;
        height: 94px;
        background-size: 100% 100%;
        background-image: url("../../assets/img/home/input-bg.png");
        position: relative;

        .inpuy-style {
          width: 383px;
          height: 43px;
          background-color: #f8fbff;
          position: absolute;
          top: 22px;
          left: 115px;
        }

        input[type="text"] {
          display: inline-block;
          font-size: 14px;
          font-family: KozMinStd-Bold;
          font-weight: bold;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #899aab;
          background: transparent;
          width: 275px;
          height: 54px;
          text-align: center;
          padding: 0 4px;
        }

        input::placeholder {
          color: #899aab;
        }
      }

      .pr {
        position: relative;
        margin-top: 12px;
        display: flex;
        align-items: center;

        .c-img {
          width: 23px;
          height: 23px;
          background-image: url("../../assets/img/home/c.png");
          background-size: 100% 100%;
        }

        .c-active-img {
          width: 28px;
          height: 23px;
          background-image: url("../../assets/img/home/c-active.png");
          background-size: 100% 100%;
        }

        .c-text {
          background-image: url("../../assets/img/home/pr.png");
          background-size: 100% 100%;
          width: 251px;
          height: 20px;
          margin-left: 8px;
        }
      }
    }

    .m-reg {
      width: 103px;
      height: 143px;
      background-size: 100% 100%;
      background-image: url("../../assets/img/home/btn.png");
      margin-left: -72px;
      z-index: 1;

    }
  }

}

.err-model {
  position: fixed;

  .err-detail {
    width: 678px;
    height: 372px;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    img {
      width: 100%;
      height: 100%;
    }

    .err-close {
      width: 60px;
      height: 60px;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/home.vue